import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import {
	type DocumentListResponseDTO,
	type DocumentTagEditRequestDTO,
	patchDocumentTagV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Props = {
	requestContract: DocumentTagEditRequestDTO;
};

export const useFolderEditMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(({ requestContract }: Props) =>
			patchDocumentTagV2(requestContract),
		),
		onMutate: async ({ requestContract }: Props) => {
			await queryClient.cancelQueries({ queryKey: DocumentKeys.list() });
			const previous = queryClient.getQueryData<DocumentListResponseDTO>(
				DocumentKeys.list(),
			);
			if (previous) {
				const updated = {
					...previous,
					tags: previous.tags.map((tag) =>
						tag.title === requestContract.titleToEdit
							? { ...tag, title: requestContract.title }
							: tag,
					),
				};
				queryClient.setQueryData(DocumentKeys.list(), updated);
			}
			return { previous };
		},
		onError: (_err, _vars, context) => {
			if (context?.previous) {
				queryClient.setQueryData(DocumentKeys.list(), context.previous);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.list() });
		},
	});
};
